import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Combobox, createListCollection } from '@chakra-ui/react';
import { useCategories } from '@client/providers/CategoriesProvider';
import { useEffect, useMemo, useState } from 'react';
const buildCategoryItems = (getChildCategories, parentId, prefix) => {
    const children = getChildCategories(parentId);
    return children.flatMap((cat) => {
        const label = prefix
            ? `${prefix}  ▸  ${cat.title}`
            : cat.title;
        return [
            { value: cat.id, label },
            ...buildCategoryItems(getChildCategories, cat.id, label),
        ];
    });
};
export const CategoryCombobox = ({ value, onChange, disabled, }) => {
    const { getChildCategories } = useCategories();
    const [inputValue, setInputValue] = useState('');
    const allItems = useMemo(() => buildCategoryItems(getChildCategories, null, ''), [getChildCategories]);
    const filteredItems = useMemo(() => {
        const q = inputValue.toLowerCase().trim();
        return q
            ? allItems.filter((item) => item.label.toLowerCase().includes(q))
            : allItems;
    }, [allItems, inputValue]);
    const collection = useMemo(() => createListCollection({
        items: filteredItems,
        itemToValue: (item) => item.value,
        itemToString: (item) => item.label,
    }), [filteredItems]);
    const selectedLabel = allItems.find((item) => item.value === value)?.label ?? '';
    useEffect(() => {
        if (selectedLabel)
            setInputValue(selectedLabel);
    }, [selectedLabel]);
    return (_jsxs(Combobox.Root, { collection: collection, value: value ? [value] : [], inputValue: inputValue, onInputValueChange: (details) => setInputValue(details.inputValue), onValueChange: (details) => {
            onChange(details.value[0] ?? null);
            const selected = allItems.find((item) => item.value === details.value[0]);
            setInputValue(selected?.label ?? '');
        }, onOpenChange: (details) => {
            if (!details.open) {
                setInputValue(selectedLabel);
            }
        }, openOnClick: true, disabled: disabled, size: "lg", children: [_jsxs(Combobox.Control, { children: [_jsx(Combobox.Input, { placeholder: "Search categories\u2026", fontSize: 18, px: 3, py: 2, name: "category" }), _jsx(Combobox.IndicatorGroup, { children: _jsx(Combobox.Trigger, {}) })] }), _jsx(Combobox.Positioner, { children: _jsxs(Combobox.Content, { maxH: 300, overflowY: "auto", children: [_jsx(Combobox.Empty, { fontSize: 18, color: "fg.muted", children: "No categories found" }), filteredItems.map((item) => (_jsxs(Combobox.Item, { item: item, cursor: "pointer", px: 3, py: 2, fontSize: 18, children: [_jsx(Combobox.ItemText, { whiteSpace: "pre-wrap", children: item.label }), _jsx(Combobox.ItemIndicator, {})] }, item.value)))] }) })] }));
};
